import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBase from 'dijit/_WidgetBase';
import RequestManager from 'more/RequestManager';
import { FeatureHelpers } from "../../more/Helpers";
import methodHooks from 'more/mdsMethodHooks';


interface WebPrivilegeEntry {
    entityID: string,
    timestamp?: Date,
    //classnames?: Array<string>,
    classname: string;
    privileges: Array<WebPrivilege>,
}
interface WebPrivilege {
    role: string,
    privilege: boolean
}

interface WhitelistResponse {
    //classnames: Array<string>;
    classname: string;
    entityIDs: Array<string>;
    ignorePrivilege?: boolean;
}

interface RunningRequest {
    targetEntityID: string,
    targetClass: string,
    mode: "whitelist" | "entityprivileges",
    callbacks: Array<Function>,
    finished: boolean
}
class WebPrivilegeManager extends methodHooks(compose(_WidgetBase)) {
    templateString = "<div></div>";

    private loadedPrivileges: Array<WebPrivilegeEntry>;
    private knownEntityIds: Array<string>;
    private completeLoadedEntityIds: Array<string>;
    private useEntityPrivileges: boolean = false;

    private _userRoleCallbacks: Array<any> = null;

    private _runningRequests: Array<RunningRequest> = [];
    private _recentRequests: Array<RunningRequest> = [];
   

    private requestManager: RequestManager;

    //private _runningRequests: Array<{
    //    guid: string,
    //    handled: boolean,
    //    results: Array<{
    //        role: string,
    //        entityID: string,
    //        result: boolean
    //    }>,
    //    callback: Function
    //}>;
    /**
     * Wenn role nicht angegeben, werden nur "komplett geladene" berücksichtigt
     */
    isLoaded(entityID: string, role?: string | Array<string>): boolean {
        if (!this.useEntityPrivileges) return true;

        let indexOfEntity = this.getIndexOfEntity(entityID, null, typeof (role) == "undefined" || role == null);
        if (indexOfEntity == -1) return false;

        let roles = [];

        if (typeof (role) != "undefined") {
            if (typeof (role) == "string") {
                roles.push(role);
            } else {
                roles = role;
            }
        } else {
            // nur komplett geladene Entities zählen
            return this.completeLoadedEntityIds.indexOf(entityID) != -1;
        }

        let entry = this.loadedPrivileges[indexOfEntity];
        let foundRoles = [];
        if (entry) {
            for (let str of roles) {
                for (let priv of entry.privileges) {
                    if (priv.role == str) {
                        foundRoles.push(str);
                        break;
                    }
                }
            }

            if (roles.length == foundRoles.length) return true;
        }

        return false;
    }

    private getIndexOfEntity(entityID: string, entityClassname: string, onlyComplete?: boolean, startIndex?: number): number {
        let index = -1;
        if (typeof (startIndex) != "number") startIndex = -1;

        for (let entry of this.loadedPrivileges) {
            index++;
            if (index >= startIndex) {
                if (entry.entityID == entityID && (entry.classname == entityClassname || entityClassname == null)) {
                    if (onlyComplete === true) {
                        let completeIndex = this.completeLoadedEntityIds.indexOf(entityID);
                        if (completeIndex != -1) {
                            return index;
                        }
                    } else {
                        return index;
                    }
                }
            }
        }
        return -1;
    }

    private getCombinedPrivilegesOfEntityId(entityID: string): WebPrivilegeEntry {
        let resultEntry: WebPrivilegeEntry = null;

        let index = this.getIndexOfEntity(entityID, null, null, -1);
        while (index != -1) {
            if (resultEntry == null) {
                resultEntry = this.loadedPrivileges[index];
            } else {

                // weitere Berechtigungen hinzufügen (erweitern und öffnen)

                let entry = this.loadedPrivileges[index];

                for (let priv of entry.privileges) {
                    let privIndex = this.getRoleIndexOfEntry(resultEntry, priv.role);
                    if (privIndex == -1) {
                        resultEntry.privileges.push(priv);
                    } else {
                        resultEntry.privileges[privIndex].privilege = resultEntry.privileges[privIndex].privilege || priv.privilege;
                    }
                }
            }


            index = this.getIndexOfEntity(entityID, null, null, index + 1);
        }

        return resultEntry;
    }

    loadPrivilegesForEntity(entity: Object, callback?: Function, forceReload?: boolean | number, classnameProperty?: string, idProperty?: string) {
        if (!entity) return;
        let _entity = entity as any;
        let classname = _entity.Classname;
        let entityID = _entity.ID;

        if (classnameProperty) classname = _entity[classnameProperty];
        if (idProperty) entityID = _entity[idProperty];


        this.loadPrivilegesForEntityID(entityID, classname, forceReload, callback);
    }
   /**
    * Lädt eine Whitelist von erlaubten Entities für eine bestimmte Rolle
    * @param rolename Benötigte Rolle
    * @param classname Klasse der Entities
    * @param callback Callback für Ergebnis (erhält true wenn offen oder Stringarray mit erlaubten Entity-IDs)
    * @param entitylistToCheck Optional: Array mit Entities oder Entity-ID-Strings, das geprüft und ggf. reduziert zurückgegeben wird im Callback
    * @param idProperty Propertyname für die EntityID, falls entitylistToCheck Objekte enthält und der Name abweichend von 'ID' ist
    * @returns
    */
    private loadWhitelist(rolename: string, classname: string, callback: Function, entitylistToCheck?: Array<any>, idProperty: string = "ID") {
        if (!this.useEntityPrivileges) {
            if (entitylistToCheck && typeof (entitylistToCheck.length) == "number") {
                // das Recht muss "einfach" vorhanden sein, ansonsten leeres Ergebnis:
                if (this.hasUserRole(rolename)) {
                    callback(entitylistToCheck, rolename);
                } else {
                    callback([], rolename);
                }
            } else {
                // das Recht muss "einfach" vorhanden sein, ansonsten false
                if (this.hasUserRole(rolename)) {
                    callback(true, rolename);
                } else {
                    callback(false, rolename);
                }
            }

            return;
        }

        for (let running of this._runningRequests) {
            if (running.mode == "whitelist" &&
                running.targetClass == classname) {

                if (running.finished != true) {
                    running.callbacks.push(callback);
                    return;
                }
            }
        }

        let requestReg: RunningRequest = {
            callbacks: [callback],
            mode: "whitelist",
            targetClass: classname,
            targetEntityID: null,
            finished: false
        };
        this._runningRequests.push(requestReg);

        if (window.standbyManager) window.standbyManager.addSpinner();

        this.requestManager.post(
            window.appRoot + "Entity/GetEntityWhitelist",
            {
                entityClass: classname,
                role: rolename
            },
            lang.hitch(this, this._onLoadWhitelistResponse, requestReg, rolename, classname, entitylistToCheck, idProperty),
            lang.hitch(this, this._onLoadWhitelistError, requestReg, rolename, classname)
        );
    }

    private _onLoadWhitelistResponse(requestReg: RunningRequest, role: string, classname: string, entitylistToCheck: Array<any>, idProperty: string = "ID", response: WhitelistResponse) {

        requestReg.finished = true;

        if (window.standbyManager) window.standbyManager.removeSpinner();

        if (response.ignorePrivilege === true) {
            for (let callback of requestReg.callbacks) {
                if (entitylistToCheck && typeof (entitylistToCheck.length) == "number") {
                    callback(entitylistToCheck);
                } else {
                    callback(true);
                }
            }
            return;
        }

        // hier kommt eine Liste von erlaubten Entities für diese Rolle für diesen Benutzer

        for (let callback of requestReg.callbacks) {
            if (entitylistToCheck && typeof (entitylistToCheck.length) == "number") {
                if (!response.entityIDs.length) {
                    callback([], role);

                } else {
                    let filterlist = [];
                    for (let entry of entitylistToCheck) {
                        if (response.entityIDs.indexOf(entry[idProperty]) != -1) {
                            filterlist.push(entry);
                        }
                    }
                    callback(entitylistToCheck, role);
                }
            } else {
                callback(response.entityIDs, role);
            }
        }

        // aus der Response noch die Entities abernten und in die geladenen Privileges stellen:
        let now = new Date();

        for (let entityID of response.entityIDs) {
            let index = this.getIndexOfEntity(entityID, classname);
            if (index == -1) {
                this.loadedPrivileges.push({
                    entityID: entityID,
                    privileges: [],
                    classname: classname,
                });

                this.knownEntityIds.push(entityID);
                index = this.getIndexOfEntity(entityID, classname);
            }
            if (index != -1) {
                let entry = this.loadedPrivileges[index];

                //entry.classnames = [...response.classnames];
                entry.classname = response.classname;
                entry.timestamp = now;
                let roleIndex = this.getRoleIndexOfEntry(entry, role);
                if (roleIndex == -1) entry.privileges.push({
                    privilege: true,
                    role: role
                })
                else {
                    let privilege = entry.privileges[roleIndex];
                    privilege.privilege = true;
                }
            }
        }

    }

    private _onLoadWhitelistError(requestReg: RunningRequest, role: string, classname: string, error: more.requestErrorMessage) {
        console.error("webprivilege whitelist loading failed", error.Message, classname);
        if (window.standbyManager) window.standbyManager.removeSpinner();
        if (this.hasUserRole("_DEV")) {
            alert("webprivilege whitelist loading failed\r\n" + "class: " + classname + "\r\n" + error.Message);
        }
        requestReg.finished = true;
        for (let callback of requestReg.callbacks) {
            callback([], role);
        }
    }
    /**
     * Alias für loadWhitelist
     */
    getWhitelist(role: string, entityClass: string, callback: Function, entitylistToCheck?: Array<any>, idProperty: string = "ID") {

        this.loadWhitelist(role, entityClass, callback, entitylistToCheck, idProperty);
    }

    /**
     * Lädt alle Webrollen des Users und prüft sie auf Gültigkeit mit einer gegebenen EntityID.
     */
    loadPrivilegesForEntityID(entityID: string,  classname: string, forceReload?: boolean | number,callback?: Function) {

        if (!this.useEntityPrivileges) {
            if (callback) callback();
            return;
        }

        if (forceReload !== true) {
            let bSkiploading: boolean = false;

            if (this.isLoaded(entityID)) {
                let index = this.getIndexOfEntity(entityID, classname, true);
                let existingEntry = this.loadedPrivileges[index];

                bSkiploading = true;

                if (typeof (forceReload) == "number") {
                    bSkiploading = false;
                    let now = new Date();
                    if (existingEntry.timestamp?.valueOf) {
                        let diff = now.valueOf() - existingEntry.timestamp.valueOf();
                        if (diff < forceReload) {
                            bSkiploading = true;
                        }
                    }
                }
            }

            if (bSkiploading === true) {
                if (callback) callback();
                return;
            }
        }

        for (let running of this._runningRequests) {
            if (running.mode == "entityprivileges" &&
                running.targetEntityID == entityID &&
                running.targetClass == classname) {

                if (running.finished != true) { 
                    running.callbacks.push(callback);
                    return;
                }
            }
        }

        let requestReg: RunningRequest = {
            callbacks: [callback],
            mode: "entityprivileges",
            targetClass: classname,
            targetEntityID: entityID,
            finished: false
        };
        this._runningRequests.push(requestReg);

        if (window.standbyManager) window.standbyManager.addSpinner();

        this.requestManager.post(
            window.appRoot + "Entity/LoadDynamicUserrolesForEntity",
            {
                "entityClass": classname,
                "entityID": entityID
            },
            lang.hitch(this, this._onLoadPrivilegesResponse, requestReg),
            lang.hitch(this, this._onLoadPrivilegesError, requestReg, entityID, classname)
        );
    }

    invalidateEntity(entity: string, idProperty: string = "ID") {
        if (!entity) return;
        if (entity && entity[idProperty]) this.invalidateEntityID(entity[idProperty]);
    }
    invalidateEntityID(entityID: string) {
        if (!entityID) return;

        let knownIndex = this.getIndexOfEntity(entityID, null)

        while (knownIndex != -1) {
            this.knownEntityIds.splice(knownIndex, 1);
            this.loadedPrivileges.splice(knownIndex, 1);
            knownIndex = this.getIndexOfEntity(entityID, null)
        }

        knownIndex = this.completeLoadedEntityIds.indexOf(entityID);

        while (knownIndex != -1) {
            this.completeLoadedEntityIds.splice(knownIndex, 1);
            knownIndex = this.completeLoadedEntityIds.indexOf(entityID);
        }
    }

    private _onLoadPrivilegesResponse(requestReg: RunningRequest, response: WebPrivilegeEntry) {
        let now = new Date();
        requestReg.finished = true;
        let existingIndex = this.getIndexOfEntity(requestReg.targetEntityID, requestReg.targetClass);

        if (window.standbyManager) window.standbyManager.removeSpinner();

        if (response) {
            if (existingIndex != -1) {
                for (let priv of response.privileges) {
                    this.setEntityPrivilege(priv.role, { ID: response.entityID, Classname: response.classname }, priv.privilege);
                }
                this.loadedPrivileges[existingIndex].timestamp = response.timestamp ? response.timestamp : now;
                if (this.completeLoadedEntityIds.indexOf(response.entityID) == -1) this.completeLoadedEntityIds.push(response.entityID);
            } else {

                if (!response.timestamp) response.timestamp = now;

                this.loadedPrivileges.push(response);
                this.knownEntityIds.push(response.entityID);
                this.completeLoadedEntityIds.push(response.entityID);
            }            
        } else {
            console.warn("privilege loading without response", requestReg, response);
            this.knownEntityIds.push(requestReg.targetEntityID);
            this.loadedPrivileges.push({
                classname: requestReg.targetClass,
                entityID: requestReg.targetEntityID,
                privileges: [],
                timestamp: now
            });
        }

        for (let callback of requestReg.callbacks) {
            try {
                callback();
            } catch (ex) {
                console.warn("webprivilege callback failed", ex);
            }
        }

        let newArray = [];

        for (let request of this._runningRequests) {
            if (request.finished === true) {
                this._recentRequests.push(request);
            } else {
                newArray.push(request);
            }
        }

        this._runningRequests = newArray;
    }

    private _onLoadPrivilegesError(requestReg: RunningRequest, entityID: string, classname: string, error: more.requestErrorMessage) {
        console.error("webprivilege loading failed", error.Message, "ID: " + entityID, "class: " + classname);

        if (window.standbyManager) window.standbyManager.removeSpinner();

        if (this.hasUserRole("_DEV")) {
            alert("webprivilege loading failed\r\n" + "class: " + classname + "\r\nID: " + entityID + "\r\n" + error.Message);
        }

        let fakeResponse: WebPrivilegeEntry = null; 

        let index = this.getIndexOfEntity(requestReg.targetEntityID, requestReg.targetClass);
        if (index != -1) fakeResponse = this.loadedPrivileges[index];
        
        this._onLoadPrivilegesResponse(requestReg, fakeResponse);
    }

    setEntityPrivilege(role: string | Array<string>, entity: any, bHasPrivilege: boolean, classnameProperty?: string, idProperty?: string): boolean {
        if (!idProperty) idProperty = "ID";
        if (!classnameProperty) classnameProperty = "Classname";

        if (!entity) return false;

        let entityID = entity[idProperty];
        let classname = entity[classnameProperty];

        let roles = [];
        if (typeof (role) == "string") roles.push(role);
        else roles = role;

        let index = this.getIndexOfEntity(entityID, classname);
        if (index == -1) {
            let now = new Date();
            let newPrivEntry: WebPrivilegeEntry = {
                classname: entity[classnameProperty],
                entityID: entity[idProperty],
                privileges: [],
                timestamp: now
            };
            this._onLoadPrivilegesResponse(null, newPrivEntry);

            index = this.getIndexOfEntity(entityID, classname);
        }

        if (index != -1) {
            let entry = this.loadedPrivileges[index];

            for (let str of roles) {
                let roleIndex = this.getRoleIndexOfEntry(entry, str);

                if (roleIndex == -1) {
                    entry.privileges.push({
                        role: str,
                        privilege: bHasPrivilege
                    })
                }

                else {
                    entry.privileges[roleIndex].privilege = bHasPrivilege;
                }
            }

            return true;
        }

        return false;
    }

    checkEntityPrivilege(role: string | Array<string>, entityClass: string, entityID: string, callback: Function, mode: "AND" | "OR" = "AND", forceReload?: boolean): boolean {

        if (!this.useEntityPrivileges) {
            if (callback) {
                callback(true, role);
            }

            return true;
        }

        let existingIndex = this.getIndexOfEntity(entityID, entityClass);
        let existingIndexWithoutClass = this.getIndexOfEntity(entityID, null);

        if (existingIndex == -1 && existingIndexWithoutClass != -1) {
            existingIndex = existingIndexWithoutClass;
        }

        let roles = [];
        if (typeof (role) == "string") roles.push(role);
        else roles = role;

        if (existingIndex == -1 || forceReload === true) {
            if (!callback) return false; // ohne Callback kann der asynchrone Ladevorgang nicht ausgeführt werden

            let nestedCallback = lang.hitch(this, this.checkEntityPrivilege, role, entityClass, entityID, callback, mode);
            this.loadPrivilegesForEntity({ ID: entityID, Classname: entityClass }, nestedCallback, false, "Classname", "ID");
        } else {
            let entry = this.getCombinedPrivilegesOfEntityId(entityID);// this.loadedPrivileges[existingIndex];
            let result = this.getPrivilegeOnEntry(entry, roles, mode);
            if (entry.entityID != this.knownEntityIds[existingIndex]) {
                alert(this.id + ": IDs do not match. internal error!\r\n" + roles)
                return false;
            }
            if (callback) {
                callback(result, role);
            }
            return result;
        }
    }

    private getRoleIndexOfEntry(entry: WebPrivilegeEntry, role: string): number {
        let index = -1;
        for (let privilege of entry.privileges) {
            index++;
            if (privilege.role == role) {
                return index;
            }
        }

        return -1;
    }
    private getPrivilegeOnEntry(entry: WebPrivilegeEntry, role: string | Array<string>, mode: "AND" | "OR" = "AND"): boolean {
        let results = [];
        let roles = [];
        if (typeof (role) == "string") roles.push(role);
        else roles = role;

        for (let str of roles) {
            let privIndex = this.getRoleIndexOfEntry(entry, str);
            if (privIndex != -1) {
                let privilege = entry.privileges[privIndex];

                results.push(privilege.privilege);
                if (mode == "OR" && privilege.privilege == true) return true;
                break;
            } else {
                results.push(false);
            }

        }

        for (let result of results) {
            if (result != true) return false;
        }

        return true;
    }
    /**
    * Async-Variante von {@link hasUserRole}
    */
    hasUserRoleAsync(role: string | Array<string>, entity?: Object, classnameProperty?: string, idProperty?: string): Promise<boolean> {
        return new Promise((resolve) => {
            this.hasUserRole(role, (res) => {
                resolve(res);
            }, entity, classnameProperty, idProperty);
        });
    }
    // bissl blöd, das ist identisch zur Funktion auf WidgetBaseSP, aber die Funktion auf WidgetbaseSP wird gebraucht
    // weil der Privilegemanager manchmal im Lifecycle erst zu spät existiert
    /**
    * Prüft ob der eingeloggte User über eine bestimmte Rolle (ein bestimmtes Recht) verfügt.
    * Durch Angabe einer optionalen Callbackfunktion kann die Prüfung asynchron funktionieren, falls zum Zeitpunkt der Prüfung die Sessiondaten noch nicht geladen sind.
    * @param role Name der Rolle oder Array mit mehrerne Rollen. Bei mehreren Rollen müssen ALLE Rollen vorhanden sein.
    * @param callback Funktion, die aufgerufen wird sobald das Ergebnis bekannt ist. Das Ergebnis der Prüfung wird mit true oder false mitgegeben.
    * @param entity Für entitybezogene Rechteprüfung dieses hier mitgeben. Standardmäßig werden ID und Classname daraus extrahiert für die Prüfung.
    * @param classnameProperty Falls das übergebene Entity ein anderslautendes Classname-Property hat, kann dieses hier bekanntgegeben werden
    * @param idProperty Falls das übergebene Entity ein anderslautendes ID-Property hat, kann dieses hier bekanntgegeben werden
    */
    hasUserRole(role: string | Array<string>, callback?: Function, entity?: any, ClassnameProperty?: string, IdProperty?: string ) {
        let tryCallback = true;

        if (window.sessionInfo?.sessionData?.Roles) {

            tryCallback = false;
            let storageDebugsetting = false;
            try {
                let data = JSON.parse(localStorage.getItem("ego_DebugUserroles"));
                storageDebugsetting = data.state === true && data.userName == window.sessionInfo.getUserName();
            } catch (ex) {

            }

            if (entity) {

                let classname = entity.Classname;
                let entityID = entity.ID;

                if (ClassnameProperty) classname = entity[ClassnameProperty];
                if (IdProperty) entityID = entity[IdProperty];

                    if (this.isLoaded(entityID, role)) {
                        let result = this.checkEntityPrivilege(role, classname, entityID, null);
                        if (callback) callback(result, role);
                        return result;
                    }

                if (!callback) return false; // ohne Callback können wir nicht asynchron anfragen obs fürs Entity passt

                this.checkEntityPrivilege(role, classname, entityID, callback);

                return false;

            }


            if (role.length && typeof (role) == "object") {
                // Array!
                let result = true;
                for (let singleRole of role) {
                    result = result && this.hasUserRole(singleRole);
                }



                if (callback) {
                    callback(result);
                }

                return result;
            }
            else if( typeof(role) == "string") {
                if (window.sessionInfo.sessionData.Roles.indexOf(role) != -1) {


                    if (storageDebugsetting) {
                        console.info("checking for role: ", role, true, this.id);
                    }

                    if (typeof (callback) == "function") {
                        callback(true);
                    }

                    return true;
                } else {
                    if (storageDebugsetting) {
                        console.warn("checking for role: ", role, false, this.id);
                    }

                    if (typeof (callback) == "function") {
                        callback(false);
                    }
                    return false;
                }
            }
        }

        if (tryCallback == true && typeof (callback) == "function") {
            this._userRoleCallbacks.push({
                role: role,
                callback: callback,
                entity: entity,
                ClassnameProperty: ClassnameProperty,
                IdProperty: IdProperty
            });
        }

        if (FeatureHelpers.hasFeature("System", "LogMissingRoles")) {
            console.info("Missing webuser role: '" + role + "' @ " + this.id);
        }
        return false;
    }
 
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);        

        this.loadedPrivileges = [];
        this.knownEntityIds = [];
        this.completeLoadedEntityIds = [];
        this._runningRequests = [];
        this._recentRequests = [];
        this.requestManager = new RequestManager();

        if (window.webPrivilegeManager) {
            window.webPrivilegeManager.destroy();
        }
        window.webPrivilegeManager = this;

        this._userRoleCallbacks = [];

        this.useEntityPrivileges = FeatureHelpers.hasFeature("system", "dynamicUserRoles"); // this._checkModule("system", "dynamicUserRoles");
    }

    destroy() {
        (this.requestManager as any).destroy();
        super.destroy.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(WebPrivilegeManager);